import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { ToastDescription, toastService } from 'components/molecules/toast';
import { OTA_LS_KEY } from 'constant/constant';
import { useTranslate } from 'hooks/use-translation';
import { isLocalhost } from 'utils/is-localhost';
import { isOrbitsEnvironment } from 'utils/is-nitro-env';
export const OTAUpdatesComponent = ()=>{
    const translate = useTranslate();
    useEffect(()=>{
        if (window.BroadcastChannel && !isLocalhost() && !isOrbitsEnvironment()) {
            const broadcast = new BroadcastChannel('count-channel');
            broadcast.onmessage = (ev)=>{
                var _ev_data;
                const isShow = localStorage.getItem(OTA_LS_KEY);
                if ((ev === null || ev === void 0 ? void 0 : (_ev_data = ev.data) === null || _ev_data === void 0 ? void 0 : _ev_data.type) === 'new_ota_updates_available') {
                    if (isShow !== 'true') {
                        localStorage.setItem(OTA_LS_KEY, 'true');
                        toastService({
                            duration: 10 * 10 * 60 * 1000,
                            message: /*#__PURE__*/ _jsx(ToastDescription, {
                                buttonText: translate('ota.action'),
                                message: translate('ota.sub_title'),
                                onClick: ()=>{
                                    localStorage.removeItem(OTA_LS_KEY);
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    window.location.reload(true);
                                }
                            }),
                            title: translate('ota.title')
                        }).info();
                    }
                }
            };
        }
    }, [
        translate
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
